var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2"},[_c('p',{staticClass:"titulo"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"descripcion"},[(_vm.value)?[_vm._v(" "+_vm._s(_vm.mappedValue)+" ")]:[_c('i',[_vm._v("No hay información")])]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }